import { Injectable, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, merge, share } from 'rxjs';

import { AuthActions } from '@app/features/auth/auth.actions';
import { selectAuthenticated } from '@app/features/auth/auth.selectors';

@Injectable({ providedIn: 'root' })
export class AuthSessionBoundaryService {
  private readonly actions = inject(Actions);
  private readonly store = inject(Store);

  public readonly synchronizationStarted = this.actions.pipe(
    ofType(AuthActions.sessionChanged),
    map(() => undefined),
    share(),
  );

  public readonly synchronizationCompleted = this.actions.pipe(
    ofType(AuthActions.sessionSynchronizationCompleted),
    share(),
  );

  public readonly synchronizationReleased = this.actions.pipe(
    ofType(AuthActions.sessionSynchronizationReleased),
    share(),
  );

  public readonly crossed = merge(
    this.store.select(selectAuthenticated).pipe(
      filter((authenticated) => !authenticated),
      map(() => undefined),
    ),
    this.actions.pipe(
      ofType(
        AuthActions.sessionSynchronizationCompleted,
        AuthActions.sessionSynchronizationRedirecting,
      ),
      filter(
        (action) =>
          action.type === AuthActions.sessionSynchronizationRedirecting.type ||
          action.identityChanged,
      ),
      map(() => undefined),
    ),
  ).pipe(share());
}
